import React from 'react';

import { Link } from 'react-router-dom';

import { RegisterLoc } from '../../loc/register';
import { loc } from '../../lib/loc';

export default function SwitchRegister() {
    return (
        <div className="registration-page pt-80 pb-150">
            <div className="registration-page__container">
                <div className="registration-page__wrap-elemets-page">
                    <div className="registration-page__left-col">
                        <div className="choice-block">
                            <div className="choice-block__wrap-elements">
                                <div className="choice-block__wrap-icon">
                                    <img
                                        className="choice-block__icon"
                                        src={`${process.env.REACT_APP_PATH}public/img/users-icon.svg`}
                                        alt=""
                                        role="presentation"
                                    />
                                </div>
                                <div className="choice-block__title">{loc(RegisterLoc.choose.personal.title)}</div>
                                <div className="choice-block__wrap-btn">
                                    <Link className="choice-block__btn" to="/register/personal/">
                                        {loc(RegisterLoc.choose.__button)}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="registration-page__right-col">
                        <div className="choice-block">
                            <div className="choice-block__wrap-elements">
                                <div className="choice-block__wrap-icon">
                                    <img
                                        className="choice-block__icon"
                                        src={`${process.env.REACT_APP_PATH}public/img/bag-icon.svg`}
                                        alt=""
                                        role="presentation"
                                    />
                                </div>
                                <div className="choice-block__title">{loc(RegisterLoc.choose.legal.title)}</div>
                                <div className="choice-block__wrap-btn">
                                    <Link className="choice-block__btn" to="/register/legal/new">
                                        {loc(RegisterLoc.choose.__button)}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
